
export default {
  SET_REPORTS(state, data) {
    state.reports = data;
  },
  SET_PAGING(state, data) {
    state.pageable = data;
  },
  RESET_STATE (state, data) {
    Object.assign(state, data)
  },
}
